import { useEffect, useState } from "react";
import Axios from "middleware/axiosInstance";
import Loading from "../../../layouts/Loading/Loading";
import useAxios from "middleware/useAxios";
import "antd/dist/antd.css";
import { Link, useNavigate } from "react-router-dom";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { Button, Space, Table } from "antd";

const Persons = () => {
  const navigate = useNavigate();
  // const [selectedItem, setSelectedItem] = useState(null);
  // const [allPersons, setAllPersons] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [allPersons, setAllPersons] = useState(null);

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  const getAllPeople = () => {
    Axios.get("/people")
      .then((res) => {
        setAllPersons(res.data);
      })
      .catch((err) => console.log(err));
  };

  const deletePersonHandler = (item) => {
    Axios.delete(`/people/${item.id}`)
      .then((res) => {
        console.log(res);
        getAllPeople();
        OpenNotificationWithIcon("حذف موفق", "حذف شخص با موفقیت انجام شد");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deletePerson = (item) => {
    if (window.confirm(`آیا شخص "${item.name} ${item.family}" حذف گردد؟ \n\n هشدار: \n تمام اسناد ثبت شده مربوط به این شخص نیز حذف می گردند!`)) {
      deletePersonHandler(item);
    }
  };

  useEffect(() => {
    getAllPeople();
  }, []);

  // table

  const columns = [
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      // filters: data.map((item) => {
      //   return (
      //     {
      //       "text": item.name,
      //       "value": item.goods_name,
      //     }
      //   )
      // }),

      // filteredValue: filteredInfo.name || null,
      // sorter: (a, b) => a.name.length - b.name.length,
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),

      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "نام خانوادگی",
      dataIndex: "family",
      key: "family",
      filters: allPersons
        ?.filter((v, i, a) => a.findIndex((v2) => v2.family === v.family) === i)
        .map((item) => {
          return {
            text: item.family,
            value: item.family,
          };
        }),
      // filterMultiple: false,
      filteredValue: filteredInfo.family || null,
      onFilter: (value, record) => record.family.includes(value),
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),
      sortOrder: sortedInfo.columnKey === "family" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "نوع",
      dataIndex: "type_person",
      key: "type_person",
      render: (shenaseh) => (
        <span>
          {shenaseh === "genuine"
            ? "حقیقی"
            : shenaseh === "legal"
            ? "حقوقی"
            : "ثبت نشده"}
        </span>
      ),
      sorter: (a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0),
      sortOrder:
        sortedInfo.columnKey === "type_person" ? sortedInfo.order : null,
      ellipsis: true,
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (a, item) => (
        <Space size="small">
          <Link
            to={`/warehouse/persons/edit/${item.id}`}
            className="btn btn-primary btn-sm"
          >
            ویرایش
          </Link>
          <Link
            to={`/warehouse/persons/details/${item.id}`}
            className="btn btn-success btn-sm"
          >
            جزییات
          </Link>
          <button
            onClick={() => deletePerson(item)}
            className="btn btn-danger btn-sm"
          >
            حذف
          </button>
        </Space>
      ),
    },
  ];

  // end table

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">اشخاص</h5>

        
        {allPersons === null ? (
          <Loading />
        ) : allPersons.length > 0 ? (
          <>
            <Space
              style={{
                marginBottom: 16,
              }}
            >
              <Button onClick={() => navigate("/warehouse/persons/create")}>
                اضافه کردن
              </Button>
              <Button onClick={clearFilters}>حذف فیلترها</Button>
              <Button onClick={clearAll}>حذف فیلتر و مرتب ها</Button>
            </Space>
            <Table
              columns={columns}
              dataSource={allPersons}
              onChange={handleChange}
              pagination={false}
            />
          </>
        ) : (

          <>
            <Space
              style={{
                marginBottom: 16,
              }}
            >
              <Button onClick={() => navigate("/warehouse/persons/create")}>
                اضافه کردن
              </Button>
            </Space>
            <h1>کاربری تعریف نشده</h1>
          </>
        )}
      </div>
    </div>
  );
};

export default Persons;
